import { connect } from 'react-redux';
import React, { PureComponent } from 'react';
import BreadcrumbsDispatcher from '@scandipwa/scandipwa/src/store/Breadcrumbs/Breadcrumbs.dispatcher';
import { updateMeta } from '@scandipwa/scandipwa/src/store/Meta/Meta.action';
import { changeNavigationState } from 'Store/Navigation/Navigation.action';
import { NavigationType } from 'Store/Navigation/Navigation.type';
import ViewDiamondPage from './ViewDiamondPage.component';
import { getQueryParam } from '@scandipwa/scandipwa/src/util/Url';
import { fetchQuery } from '@scandipwa/scandipwa/src/util/Request/Query';
import DiamondQuery from 'Query/DiamondQuery.query';

/** @namespace Route/CmsPage/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    device: state.ConfigReducer.device,
});

/** @namespace Route/CmsPage/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    updateBreadcrumbs: (breadcrumbs) => BreadcrumbsDispatcher.update(breadcrumbs, dispatch),
    updateMeta: (meta) => dispatch(updateMeta(meta)),
    setHeaderState: (stateName) => dispatch(changeNavigationState(NavigationType.TOP_NAVIGATION_TYPE, stateName)),
});

export class ViewDiamondPageContainer extends PureComponent {
    static propTypes = {
        device: this.propTypes,
        updateBreadcrumbs: this.propTypes,
        updateMeta: this.propTypes,
        setHeaderState: this.propTypes
    }

    state = {
        diamond: [],
        isLoading: true
    }

    async componentDidMount() {
        this.updateBreadcrumbs();
        this.uppdateMeta();
        this.updateHeader();

        window.scrollTo(0, 0);

        this.setState({
            isLoading: true
        });

        const diamond_sku = getQueryParam("diamond_sku", location);

        if (diamond_sku) {
            const { getDiamondsBySku } = await fetchQuery(DiamondQuery.getDiamond(diamond_sku));

            if (getDiamondsBySku?.product?.length > 0) {
                this.setState({
                    diamond: getDiamondsBySku?.product,
                    isLoading: false
                });
            } else {
                this.setState({
                    isLoading: false
                });
            }
        } else {
            this.setState({
                isLoading: false
            });
        }
    }

    componentDidUpdate() {
        this.updateBreadcrumbs();
        this.uppdateMeta();
        this.updateHeader();
    }

    updateBreadcrumbs() {
        const { updateBreadcrumbs } = this.props;

        const breadcrumbs = [
            {
                url: '/view_diamond',
                name: 'Diamond',
            },
        ];

        updateBreadcrumbs(breadcrumbs);
    }

    uppdateMeta() {
        const { updateMeta } = this.props;

        updateMeta({
            title: "Diamond",
            description: "Diamond",
            keywords: "Diamond",
            canonical_url: window.location.href,
        });
    }

    updateHeader() {
        const { setHeaderState } = this.props;

        setHeaderState({
            name: "Diamond",
            title: "Diamond",
        });
    }

    containerProps() {
        const { device } = this.props;
        const { diamond, isLoading } = this.state;

        return {
            device,
            diamond,
            isLoading
        };
    }

    render() {
        return (
            <ViewDiamondPage
                {...this.containerProps()}
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewDiamondPageContainer);
